export const CATEGORIE_PRODUITS_SURFACES_ACTUELLES = {
  ELEVAGE: {
    couleur: "#B57A60",
    code: "EL",
    libelle: "Viande, oeufs et produits laitiers",
    libelle_affichage: "Viande, oeufs et produits laitiers",
  },
  FRUITS: {
    couleur: "#A261C0",
    code: "FR",
    libelle: "Fruits",
    libelle_affichage: "Fruits",
  },
  LEGUMES: {
    couleur: "#91C423",
    code: "LG",
    libelle: "Légumes",
    libelle_affichage: "Légumes",
  },
  JACHERES: {
    couleur: "#91C423",
    code: "JA",
    libelle: "Jachères",
    libelle_affichage: "Jachères",
  },
  CEREALES: {
    couleur: "#F9B233",
    code: "GC",
    libelle: "Céréales et grandes cultures (hors alimentation animale)",
    libelle_affichage:
      "Céréales et grandes cultures (hors alimentation animale)",
  },
  INDUSTRIE: {
    couleur: "#62D5F3",
    code: "IN",
    libelle: "Autres cultures industrielles",
    libelle_affichage: "Autres cultures industrielles",
  },
};
